export const initMobileNavigation = header => {
    if (!header) return;

    const mobileNavigation = header.querySelector('.mobile-navigation');
    if (!mobileNavigation) return;

    // Get the offset width of the html element width.
    let width = document.documentElement.offsetWidth || 0;
    let position = 0;

    // Use a resize observer instead of the window resize event.
    const resizeObserver = new ResizeObserver(entries => {
        if (entries[0].target === header) {
            const top = entries[0].target.offsetHeight;
            mobileNavigation.style.setProperty('top', `${top}px`);

            width = document.documentElement.offsetWidth || 0;
            let left = 0;

            // Fix position on the second and third submenu level.
            for (let i = 0; i < position; i++) {
                left -= width;
                menus.style.setProperty('transform', `translateX(${left}px)`);
            }
        }
    });

    resizeObserver.observe(header);

    const menus = mobileNavigation.querySelector('.menus');
    if (!menus) return;

    // Get the duration from the "menus" element.
    const duration = parseFloat(window.getComputedStyle(menus).transitionDuration) * 1000;

    /**
     * Move the menu to the left or right.
     *
     * @param toLeft
     */
    const moveMenus = toLeft => {
        // m41 is the current "transform: translateX" value
        let left = new DOMMatrix(window.getComputedStyle(menus).transform).m41 || 0;
        left = toLeft ? left - width : left + width;
        position = toLeft ? position + 1 : position - 1;
        menus.style.setProperty('transform', `translateX(${left}px)`);
    };

    // Add click event listener to right arrow.
    menus.querySelectorAll('.arrow-right').forEach(arrowRight => {
        const select = () => {
            // Get the id from the closest menu item.
            const id = arrowRight.closest('.menu-item')?.id?.replace('mobile-item-', '') || '';
            menus.querySelector(`#mobile-submenu-${id}`)?.classList.remove('hidden');
            moveMenus(true);
        }

        arrowRight.addEventListener('click', select);
        arrowRight.closest('.menu-item-content')?.querySelector('.item-content')?.addEventListener('click', select);
    });

    // Add click event listener to "back" menu item.
    menus.querySelectorAll('.mobile-menu-back').forEach(back => {
        back.addEventListener('click', () => {
            // Hide the closest menu after the duration.
            setTimeout(() => back.closest('.mobile-menu')?.classList?.add('hidden'), duration);
            moveMenus(false);
        });
    });
};
